var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIconFixedRate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7915 3.95817H8.20817V5.37484H6.7915V3.95817ZM7.49984 11.0415C7.88942 11.0415 8.20817 10.7228 8.20817 10.3332V7.49984C8.20817 7.11025 7.88942 6.7915 7.49984 6.7915C7.11025 6.7915 6.7915 7.11025 6.7915 7.49984V10.3332C6.7915 10.7228 7.11025 11.0415 7.49984 11.0415ZM7.49984 0.416504C3.58984 0.416504 0.416504 3.58984 0.416504 7.49984C0.416504 11.4098 3.58984 14.5832 7.49984 14.5832C11.4098 14.5832 14.5832 11.4098 14.5832 7.49984C14.5832 3.58984 11.4098 0.416504 7.49984 0.416504ZM7.49984 13.1665C4.37609 13.1665 1.83317 10.6236 1.83317 7.49984C1.83317 4.37609 4.37609 1.83317 7.49984 1.83317C10.6236 1.83317 13.1665 4.37609 13.1665 7.49984C13.1665 10.6236 10.6236 13.1665 7.49984 13.1665Z",
    fill: "#4E5D78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconFixedRate);
export default __webpack_public_path__ + "static/media/info-icon-fixed-rate.44f595d633f50ca8a30ec0859a56fd6f.svg";
export { ForwardRef as ReactComponent };